// //for PROD Tenant Environment
export const environment = {
  production: true,
  tenant: "5b268d57-2a6f-4e04-b0de-6938583d5ebc",
  clientID: '95ef12f8-f1a8-42ad-b238-3b2c2ca3c3c2',
  authority: 'https://login.microsoftonline.com/5b268d57-2a6f-4e04-b0de-6938583d5ebc',
  storeAuthStateInCookie: false,
  defaultScope: "api://95ef12f8-f1a8-42ad-b238-3b2c2ca3c3c2/AccessAsUser",
  redirectUri : "https://mercurydev.products.abbott",
  apiBaseURL: "/api",
  apiURL: "https://mercurydev.products.abbott"
};

// Abbott QA tenent
// export const environment = {
//   production: false,
//   tenant: "13f80aea-1087-4d3f-840d-6d693e9799d8",
//   clientID: 'f4d039a7-e523-49cd-9ff7-06b2e0d7f33a',
//   authority: 'https://login.microsoftonline.com/13f80aea-1087-4d3f-840d-6d693e9799d8',
//   storeAuthStateInCookie: false,
//   defaultScope: "api://f4d039a7-e523-49cd-9ff7-06b2e0d7f33a/AccessAsUser",
//   redirectUri : "http://localhost:4200",
//   apiBaseURL: "/api",
//   apiURL: "https://mercurydev.products.abbott"
// };
